// Lib
import React, { useState } from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import useUser from '../../hooks/useUser';
import { useStyles } from './NestedListStyles';

const NestedList = ({
  title,
  items,
  name,
  onChange = () => {},
  withChanges,
  orderBy,
  sortButton,
}) => {
  const { isKiteUser } = useUser();
  const { classes, cx } = useStyles({ isKiteUser });
  const [open, setOpen] = useState(false);

  const onClick = () => {
    setOpen(!open);
  };

  return (
    <List
      className={classes.list}
      component="nav"
      aria-labelledby="nested-list-subheader">
      <ListItemButton className={classes.listItem} onClick={onClick}>
        <ListItemText className={classes.title}>
          {title} {withChanges && !open && <div className={classes.circle} />}
        </ListItemText>
        {open ? (
          <ExpandLess className={classes.icon} />
        ) : (
          <ExpandMore className={classes.icon} />
        )}
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List className={classes.collapsedList} component="div" disablePadding>
          {items?.map(({ title, checked }) => (
            <ListItemButton
              onClick={
                sortButton ? onChange(title) : onChange(name, title, checked)
              }
              key={title}
              className={cx(
                classes.button,
                (checked || title?.toLowerCase() === orderBy?.toLowerCase()) &&
                  classes.activeButton,
              )}>
              {title}
            </ListItemButton>
          ))}
          {sortButton && sortButton}
        </List>
      </Collapse>
    </List>
  );
};

export default NestedList;
